module.exports = __webpack_public_path__ + "img/15.23a3563a.png";